import { createContext, useContext } from 'react';

export const LayerContext = createContext();

export const LayerProvider = LayerContext.Provider;

export const useLayerContext = () => useContext(LayerContext);
